import type { LinkNavTab } from '@shared/ui/menus'

import { useSidebarPrivileges } from '@entities/viewer'
import { resolveUrl } from '@shared/lib/url'
import { useAdminRoutes } from '@shared/lib/routes'
import { AppRoute } from '@shared/config'

interface TutorDetailMenuReturn {
  config: ComputedRef<LinkNavTab[]>
}

export const useTutorDetailMenu = (): TutorDetailMenuReturn => {
  const route = useRoute()
  const privileges = useSidebarPrivileges()

  // Built inside computed so the tabs follow route.params.id when the
  // component instance is reused across different tutors.
  const config = computed<LinkNavTab[]>(() => {
    const tutorId = route.params.id as string

    const generalInfoUrl = useAdminRoutes('admin.tutor.show', { tutor_id: tutorId }) ?? ''
    const additionalInfoUrl = useAdminRoutes('admin.tutors.additional-info', { tutor_id: tutorId }) ?? ''
    const scheduleUrl = useAdminRoutes('admin.tutors.schedule.show', { tutor_id: tutorId }) ?? ''
    const linksUrl = useAdminRoutes('admin.tutors.links.show', { tutor_id: tutorId }) ?? ''
    const changelogUrl = useAdminRoutes('admin.changelog.tutor', { tutor_id: tutorId }) ?? ''
    const paymentPolicyUrl = resolveUrl(AppRoute.TutorsPaymentPolicy, { id: tutorId }) ?? ''
    const legalUrl = resolveUrl(AppRoute.TutorsLegal, { id: tutorId }) ?? ''

    return [
      {
        text: 'General info',
        to: generalInfoUrl,
        selected: false,
        disabled: false,
        visible: true,
      },
      {
        text: 'Additional info',
        to: additionalInfoUrl,
        selected: false,
        disabled: false,
        visible: true,
      },
      {
        text: 'Schedule',
        to: scheduleUrl,
        selected: false,
        disabled: false,
        visible: true,
      },
      {
        text: 'Links',
        to: linksUrl,
        selected: false,
        disabled: false,
        visible: true,
      },
      {
        text: 'Changelog',
        to: changelogUrl,
        selected: false,
        disabled: false,
        visible: true,
      },
      {
        text: 'Payment policy',
        to: paymentPolicyUrl,
        selected: route.path === paymentPolicyUrl,
        disabled: false,
        visible: true,
      },
      {
        text: 'Legal',
        to: legalUrl,
        selected: route.path === legalUrl,
        disabled: false,
        visible: privileges.canManageTutorBilling.value,
      },
    ]
  })

  return {
    config,
  }
}
